import { useState } from "react";
import ImagePreview from "../../Common/UI/ImagePreview";
import { SxProps, TextField, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

type Props = {
  currentQuestion: any;
};

const radioWrapperStyle: SxProps = {
  width: "350px",
  minHeight: "55px",
  borderRadius: 1,

  border: "1px solid",
  borderColor: "divider",

  "&:hover": {
    cursor: "pointer",
    bgcolor: "secondary.main",
    borderColor: "primary.main",

    "&>div": {
      borderColor: "primary.main",
      color: "primary.main",
    },
    "& .MuiBox-root": {
      borderColor: "primary.main",
    },
  },
};

const radioIndex: SxProps = {
  p: 2,
  display: "flex",
  borderRight: "1px solid",
  borderColor: "divider",
  minWidth: "48px",
  height: "100%",
  justifyContent: "center",
};

const radioValue: SxProps = {
  p: 2,
  flex: 1,
  alignItems: "center",
  justifyContent: "space-between",
};

const RadioFieldPreview = ({ currentQuestion }: Props) => {
  const { choices, properties } = currentQuestion;
  const [imagePreview, setImagePreview] = useState<string>("");
  const showImagePreview = (
    event: React.MouseEvent<HTMLElement>,
    url: string
  ) => {
    event.stopPropagation();
    setImagePreview(url);
  };

  const closeImagePreview = () => {
    setImagePreview("");
  };

  const getDisplayType = (index: number, value?: string) => {
    if (properties.bulletStyle === "alphabetical") {
      return String.fromCharCode(65 + index);
    } else if (properties.bulletStyle === "numerical") {
      return index + 1;
    } else if (properties.bulletStyle === "values") {
      return value;
    } else if (properties.bulletStyle === "bullets") {
      return "•";
    } else {
      return String.fromCharCode(65 + index);
    }
  };

  return (
    <div
      className={
        properties?.orientation === "vertical"
          ? "radio-preview vertical"
          : "radio-preview"
      }
    >
      {choices?.map((choice: any, index: number) => (
        <Stack
          key={choice?.id}
          direction={"row"}
          gap={1}
          alignItems={"center"}
          sx={radioWrapperStyle}
        >
          <div className="radio-preview-item">
            <Box sx={radioIndex}>{getDisplayType(index, choice?.value)}</Box>
            {choice.previewUrl && (
              <div
                className="radio-image-preview"
                onClick={(e) => showImagePreview(e, choice.previewUrl)}
              >
                <img
                  src={choice.previewUrl}
                  alt="preview"
                  style={{
                    maxHeight: "50px",
                    maxWidth: "192px",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
            <Stack
              sx={radioValue}
              direction={choice?.isOther ? "column-reverse" : "row"}
              gap={1}
            >
              <Typography fontWeight={"regular"} title={choice?.label}>
                {choice?.label}
              </Typography>
              {choice?.isOther && (
                <TextField
                  fullWidth
                  name="textValue"
                  placeholder="Enter Value"
                  sx={{ bgcolor: "white" }}
                />
              )}
            </Stack>
          </div>
        </Stack>
      ))}
      {imagePreview && (
        <ImagePreview
          closeHandler={closeImagePreview}
          image={imagePreview || ""}
        />
      )}
    </div>
  );
};
export default RadioFieldPreview;
